import React from 'react';
import { connect } from 'react-redux';

import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { setNewForm } from 'apps/auth/actions/formAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, IconWrapper } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import MainOfakimHandleModal from 'apps/auth/components/send/ofakim/MainOfakimHandleModal';
import MainOfakimModal from 'apps/auth/components/send/ofakim/MainOfakimModal';
import { toLowerCase } from 'apps/auth/helpers/utils';

import { LimitBlock } from '../gaLimits/LimitBlock';

const IsraelLimits = (props) => {
    const onClickEvent = () => {
        if ((props.show_modal_kyc_increase_limit || props.ofakimFlowUpdateProfile) && !!props.ofakimHandleKycFlow === false) {
            props.toggleModal(
                true,
                <MainOfakimModal
                    onClickNotNow={(e) => {
                        e.preventDefault();
                        props.toggleModal(false);
                    }}
                    toggleSpinner={props.toggleSpinner}
                    setNewForm={props.setNewForm}
                    showIntro={false}
                    addExtras={props.addExtras}
                    updatePageMessages={props.updatePageMessages}
                    onClickOfakimStatus={() => props.toggleModal(false)}
                    insideModalComponent
                />,
            );
        }
        if ((props.show_modal_kyc_increase_limit || props.ofakimFlowUpdateProfile) && !!props.ofakimHandleKycFlow) {
            props.toggleModal(
                true,
                <MainOfakimHandleModal
                    onClickNotNow={(e) => {
                        e.preventDefault();
                        props.toggleModal(false);
                    }}
                    toggleSpinner={props.toggleSpinner}
                    setNewForm={props.setNewForm}
                    showIntro={false}
                    addExtras={props.addExtras}
                    updatePageMessages={props.updatePageMessages}
                    onClickOfakimStatus={() => props.toggleModal(false)}
                    insideModalComponent
                />,
            );
        }
    };

    return (
        <>
            <Separator marginBottom="48px" />
            <Text variant="div" indent="adaptive-16-24">
                {props.ofakimGtLimits}
            </Text>
            {props.locked && (
                <Text variant="div" size="header" color="secondary" indent="adaptive-8-16">
                    {props.gtLimitLocked}
                </Text>
            )}
            {!props.locked && !props.ofakimInProgress && (
                <Row indent="adaptive-32-48">
                    <LimitBlock
                        progressWidth={props.tffLimit.usedPercent}
                        isExhaustedLimit={props.alarmLimits <= props.tffLimit.usedPercent}
                        currency={toLowerCase(props.tffLimit.currencyCode)}
                        spendSum={props.tffLimit.formatedUsed}
                        spendText={props.profileSpent}
                        leftSum={props.tffLimit.formatedMax}
                        leftText={props.leftText}
                        isLimitError={props.tffLimit.max === 0}
                        limitErrorText={props.profileLimitFrodError}
                    />
                </Row>
            )}
            {!props.hideIncreaseLimitButton && !props.ofakimInProgress && (
                <Panel type="button" onClick={onClickEvent} isHoverable negativeMargin>
                    <DiskBadgeWrapper>
                        <DiskBadge variant="secondary" iconName="arrow-up" />
                    </DiskBadgeWrapper>
                    <Text color="primary">{props.gaLimitProcessButton}</Text>
                </Panel>
            )}
            {props.ofakimInProgress && (
                <Panel negativeMargin isDefaultCursor>
                    <IconWrapper>
                        <Icon name="clock" size="24px" />
                    </IconWrapper>
                    <Text>{props.limitsReviewingDocument}</Text>
                </Panel>
            )}
        </>
    );
};

export default connect(null, { toggleModal, toggleSpinner, setNewForm, updatePageMessages, addExtras })(IsraelLimits);
